import React from 'react';
import PropTypes from 'prop-types';
import { Col, KeyValue, NoValue, Row } from '@folio/stripes-components';
import { FormattedDate } from 'react-intl';
import { getCustomFieldValue } from '../../../../utils/utils';

function DateFieldView({ fieldValues, locale, data }) {
  const { name, label, schema } = fieldValues;
  const fieldLabel = label.find((field) => field.locale === locale)?.value;
  const fieldValue =
    schema === 'default' ? data[name] : getCustomFieldValue(name, data);

  return (
    <Row>
      <Col xs={12}>
        <KeyValue
          label={fieldLabel}
          value={
            fieldValue ? <FormattedDate value={fieldValue} /> : <NoValue />
          }
        />
      </Col>
    </Row>
  );
}

DateFieldView.propTypes = {
  fieldValues: PropTypes.object,
  locale: PropTypes.string,
  data: PropTypes.object,
};

export default DateFieldView;
